export default __webpack_public_path__ + "static/media/gmail-icon.782aeab3.svg";